import { Typography } from "@mui/material";

export const PushCallDialog = (
  <div>
    <Typography maxWidth={350}>
      <strong>
        A call will be pushed to the user with their current playlist. Would you
        like to continue?
      </strong>
    </Typography>
  </div>
);

export const PushMaintenanceCallDialog = (
  <div>
    <Typography maxWidth={350}>
      <strong>
        A call will be pushed to the user with their maintenance program. Would you
        like to continue?
      </strong>
    </Typography>
  </div>
);
